<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all">
        <!-- 顶部搜索模块 -->
        <div class="searchContainer flex-shrink">
            <baseSearch :searchData="searchData" :isShowExport="isShowExport" @searchClick="searchBtnClick" @exportClick="exportBtnClick"/>
        </div>

        <div class="mainTable" :style="{'height':tableBoxHeight + 'px'}">
            <!-- 主体表格 -->
            <div class="btnWarp flex-shrink" >
                <el-button plain type="primary" class="tableOptionBtn" @click="intimidateOrder(2,$event)">回滚选中订单制作状态</el-button>
                <el-button plain type="primary" class="tableOptionBtn" @click="intimidateOrder(0,$event)">回滚当前页订单制作状态</el-button>
            </div>
            <basetable tableId="workOrderListTable" :tableHeight="tableListHeight"  :tableTitle="tableTitle" :tableData="tableData" :showopera="false" :currentPage="searchDataParam.pageNo" operaWidth="140"
                       :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showSelection="true" :showNumber="true"
                       :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                       @currentChange="currentChange" @sizeChange="sizeChange" >

            </basetable>
        </div>
<!--        <div class="actionBar flex align-center justify-between">-->
<!--            <div class="flex align-center justify-start">-->
<!--                <div class="catalogue">{{catalogue || "暂无目录"}}</div>-->
<!--                <el-button  plain type="primary" class="tableOptionBtn" >请选择导出目录</el-button>-->
<!--            </div>-->
<!--            <div>-->
<!--                <el-button  plain type="primary" class="tableOptionBtn" >中止</el-button>-->
<!--                <el-button  plain type="primary" class="tableOptionBtn" >开始</el-button>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import WangEditor from '@/components/wangEditor'
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
    inject: ['$http', '$api', '$utils','$userUtils'],
    name: "orderList",
    components: {
        baseSearch,
        basetable,
        basedialog,
        tableDataSelect,
        WangEditor
    },
    data() {
        return{
            searchData: [
                {
                    label: "订单号",
                    type: "input",
                    name: "orderNo",
                    value: ""
                },{
                    label: "生产编码",
                    type: "input",
                    name: "productNum",
                    value: ""
                },{
                    label: "pdf生成状态",
                    type: "select",
                    name: "pdfStatus",
                    options: [],
                },{
                    label: "产品类型",
                    type: "select",
                    name: "prodType",
                    value: "",
                    options: [],
                },{
                    label: "生产批次",
                    type: "input",
                    name: "productBatch",
                    value: ""
                },{
                    label: "订单状态",
                    type: "select",
                    name: "orderStatus",
                    options: [],
                },{
                    label: "产品名称",
                    type: "input",
                    name: "productName",
                    value: ""
                }, {
                    label: "生产时间",
                    type: "datetimerange",
                    name: "productTime",
                    value: [],
                }, {
                    label: "支付时间",
                    type: "datetimerange",
                    name: "payTime",
                    value: ["",""],
                }
            ],
            isLoading: false,
            tableTitle: [
                {
                    label: '订单号',
                    prop: 'orderNo',
                    width:160
                }, {
                    label: '生产编码',
                    prop: 'productNum',
                    width: 250
                },{
                    label: "产品类型",
                    prop: "proTypeStr",
                    width: 120
                }, {
                    label: '产品名称',
                    prop: 'proName',
                    width: 200
                }, {
                    label: '订单状态',
                    prop: 'statusStr',
                    width: 120
                }, {
                    label: 'PDF生成状态',
                    prop: 'pdfStatusStr',
                    width:120
                }, {
                    label: '生产批次号',
                    prop: 'productBatch',
                    width: 120
                }, {
                    label: '支付时间',
                    prop: 'payTime',
                    width:180
                }
            ],
            tableData: [],
            orderIds: [],
            total: 0,
            searchDataParam:{
                pageNo:1,
                pageSize:20,
            },
            tableBoxHeight: 0 ,
            tableListHeight: 0,
        }
    },
    mounted() {
        //获取生产商账号筛选项
        // this.getProductUserOptions();

        //公共字典
        this.getCommonDicts();

        this.tableBoxHeight = document.getElementsByClassName("container")[0].offsetHeight - document.getElementsByClassName("searchContainer")[0].offsetHeight  - 20;

        this.tableListHeight = this.tableBoxHeight - document.getElementsByClassName("btnWarp")[0].offsetHeight;

        console.log("tableBoxHeight",this.tableBoxHeight,)
    },

    methods:{
        /**
         * 获取生产商账号筛选项
         */
        getProductUserOptions() {
            let that = this;
            that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
                if(res.code == 200) {
                    that.searchData[0].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[0].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
        },
        /**
         * 根据类型获取字典数据
         * @param {Object} dictType
         */
        getCommonDicts(dictType) {
            let that = this;
            that.$http.post(that.$api.getCommonDictsApi, {
                "type": "产品类型",
                "parent": 0
            }).then(res => {
                if(res.code == 200) {
                    that.searchData[3].options = [];
                    res.data.forEach((item,index)=>{
                        that.searchData[3].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
            that.$http.post(that.$api.getCommonDictsApi, {
                "type": "订单生成状态",
            }).then(res => {
                if(res.code == 200) {
                    that.searchData[2].options = [];
                    res.data.forEach((item,index)=>{
                        that.searchData[2].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
            that.$http.post(that.$api.getCommonDictsApi, {
                "type": "订单状态",
            }).then(res => {
                if(res.code == 200) {
                    that.searchData[5].options = [];
                    res.data.forEach((item,index)=>{
                        that.searchData[5].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
        },
        /**
         * 获取工单列表数据
         */
        initData() {
            let that = this;
            that.loading = true;
            that.$http.postRaw(that.$api.queryUserOrderProductListPageApi,that.searchDataParam ).then(res => {
                that.loading = false;
                if(res.code == 200) {
                    if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
                    that.tableData = res.data.list;
                    if(that.tableData.length > 0) {
                        that.tableData.forEach((item, index) => {
                            item.payTime = that.$utils.isEmpty(item.payTime) ? "--" : that.$utils.getDateTime(item.payTime);

                        })
                    }
                }
            })
        },

        /**
         * 搜索按钮
         */
        searchBtnClick(option){
            let that = this;
            console.log("option",option)
            if (this.$utils.isEmpty(option.payTime)) {
                this.searchDataParam.payStartTime = '';
                this.searchDataParam.payEndTime = '';
            } else {
                this.searchDataParam.payStartTime = option.payTime[0];
                this.searchDataParam.payEndTime = option.payTime[1];
            }
            if (this.$utils.isEmpty(option.productTime)) {
                this.searchDataParam.productStartTime = '';
                this.searchDataParam.productEndTime = '';
            } else {
                this.searchDataParam.productStartTime = option.productTime[0];
                this.searchDataParam.productEndTime = option.productTime[1];
            }

            this.searchDataParam.orderProductQueryType = 3;
            this.searchDataParam = Object.assign(this.searchDataParam,option);
            this.searchDataParam.pageNo = 1;
            console.log(option,this.searchDataParam)
            this.initData()
        },
        /**
         * 设置页码
         */
        currentChange(val){
            this.searchDataParam.pageNo = val;
            this.initData()
        },
        /**
         * 设置页码
         */
        sizeChange(val){
            this.searchDataParam.pageSize = val;
            this.initData()
        },
        /**
         * 复选框
         */
        selectionChange(val) {
            this.orderIds = val;
            console.log(val)
        },
        /**
         * 打单按钮点击事件
         * type: 1:全部打印  2:批量打印
         */
        intimidateOrder(type,evt) {
            let that = this;
            let orderIdListJson = [];
            let target = evt.target;
            if (target.nodeName == "SPAN") {
                target = evt.target.parentNode;
            }
            target.blur();
            console.log(that.orderIds)
            if(type == 2){

                if(that.orderIds.length == 0){
                    that.$message.warning("请选择要回滚的订单");
                    return
                }
                that.orderIds.forEach((item) => {
                    orderIdListJson.push(item.orderId)
                })
            }else{
                if(that.tableData.length == 0){
                    that.$message.warning("请选择要回滚的订单");
                    return
                }
                that.tableData.forEach((item) => {
                    orderIdListJson.push(item.orderId)
                })
            }
            if (orderIdListJson.length > 0 ) {
                console.log(that.formData)

                that.$loading();
                that.$http.post(that.$api.rollBackOrderCheckYesStatusApi, {
                    "orderIdListJson": JSON.stringify(orderIdListJson),
                }).then(res => {

                    if (res.code == 200) {
                        setTimeout(()=>{
                            that.$loading().close();
                            this.searchDataParam.pageNo = 1;
                            this.initData()
                        },500)
                    }else {
                        that.$loading().close();
                    }
                })
            } else {
                that.$message.warning("请选择要回滚的订单");
                return
            }
        },
    },
}
</script>
<style scoped>
.mainCont .container{
    padding: 0;
    background-color: #F5FBFF;
    border-radius: 12px;
    box-sizing: border-box;
}
.searchContainer{
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
}
.mainTable{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    height: 66%;
    overflow: hidden;
    /*margin-bottom: 20px;*/
}

.actionBar{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    height: 4%;
}
.catalogue{
    margin-right: 20px;
    font-size: 14px;
}
</style>
<style>

</style>